
import $ from "jquery"
import { EventEmitter } from "events"
import { Factory as CopyButton } from "concepts/listings/share/bar/components/copy_button/index"


interface Selector {
  main: string
  wechat_btn: string
  wechat_close: string
  url_share: string
}
interface InputSelector {
  main?: string
  wechat_btn?: string
  wechat_close?: string
  url_share?: string
}
const default_selector = {
  main: ".cell--listings--share--bar",
  wechat_btn: ".cell--listings--share--bar--wechat-button",
  wechat_close: ".cell--listings--share--bar--wechat-overlay--close",
  url_share: ".cell--listings--share--bar--url-share",
}


class ListingShareBar extends EventEmitter {
  private selector: Selector
  private $el: JQuery
  private $wechat_btn: JQuery
  private $wechat_close: JQuery
  private $url_share: JQuery

  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, default_selector, selector)
    this.$el = $(this.selector.main)
    this.$wechat_btn = this.$el.find(this.selector.wechat_btn)
    this.$wechat_close = this.$el.find(this.selector.wechat_close)

    this.$url_share = this.$el.find(this.selector.url_share)

    this.bind_action()
  }

  protected bind_action(){
    this.$wechat_btn.on("click", (e) => {
      e.preventDefault()
      $("body").addClass("page--filter--js-expanded")
      this.$el.addClass("cell--listings--share--bar--wechat-show")
    })

    this.$wechat_close.on("click", (e) => {
      e.preventDefault()
      $("body").removeClass("page--filter--js-expanded")
      this.$el.removeClass("cell--listings--share--bar--wechat-show")
    })

    this.$url_share.each((_idx, link) => {
      const $link = $(link)
      CopyButton.create({
        scope: this.$el,
        button: $link,
      })
    })
  }
}

const Factory = {
  create(selector?: InputSelector){
    return new ListingShareBar(selector)
  },
}

export {
  Factory as default,
  Factory,
}
